import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { useStore } from "@/store";
import CustomSVG from "@/components/custom/CustomSVG.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SmallLoading',
    setup: function (__props) {
        var store = useStore();
        return function (_ctx, _cache) {
            var _component_n_icon = _resolveComponent("n-icon");
            return (_unref(store).smallLoadConnection !== 0)
                ? (_openBlock(), _createBlock(_component_n_icon, {
                    key: 0,
                    size: "1.5rem",
                    class: "small-loading-icon"
                }, {
                    default: _withCtx(function () { return [
                        _createVNode(CustomSVG, { icon: "SmallLoading" })
                    ]; }),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
